import React, { useContext } from 'react';
import { CheckoutContext, CheckoutContextProps } from '../../context/CheckoutContext';
import { isAsaCompany } from '../../Utils/asaBrand';

interface AsaRouteProps {
  /** What All Sports Arena sees on this route */
  asa: React.ReactNode;
  /** Every other company, unchanged */
  children: React.ReactNode;
}

/** One route, two designs: ASA's page for All Sports Arena, the existing page for everyone else. */
const AsaRoute: React.FC<AsaRouteProps> = ({ asa, children }) => {
  const { company } = useContext(CheckoutContext) as CheckoutContextProps;
  return <>{isAsaCompany(company) ? asa : children}</>;
};

export default AsaRoute;
